module.exports = __webpack_public_path__ + "img/Speaker=Iris Guo.58b937ac.png";